import axios from "axios";
import VueAxios from "vue-axios";
export default {
  install(Vue) {
    axios.defaults.baseURL = "http://iot.aithings.vn:24680/api/" //http://10.1.50.100:13579/api/";  //    http://localhost:1337/
                                                                  //    http://iot.aithings.vn:24680/api/
    Vue.use(VueAxios, axios);
  }
};